import AppConfig from 'utils/app-config';

class FacebookService {
  init() {
    return new Promise((resolve) => {
      if (AppConfig.get('facebookInitialized')) {
        return resolve();
      }
      window.fbAsyncInit = function fbAsyncInit() {
        window.FB.init({
          appId: AppConfig.get('facebookId'),
          cookie: false,
          version: 'v14.0',
        });

        AppConfig.merge({ facebookInitialized: true });
        resolve();
      };

      (function facebookScriptInjection(d, s, id) {
        const fjs = d.getElementsByTagName(s)[0] || d.getElementsByTagName('body')[0];
        if (d.getElementById(id)) { return; }
        const js = d.createElement(s);
        js.id = id;
        js.src = 'https://connect.facebook.net/en_US/sdk.js';
        fjs.parentNode.insertBefore(js, fjs);
      }(document, 'script', 'facebook-jssdk'));

      return true;
    });
  }

  getLoginStatus() {
    return new Promise((resolve) => {
      window.FB.getLoginStatus((response) => {
        resolve(response);
      });
    });
  }

  logout() {
    return new Promise((resolve) => {
      window.FB.logout(() => {
        resolve();
      });
    });
  }

  login() {
    return new Promise((resolve) => {
      window.FB.login(
        (response) => {
          resolve(response);
        },
        {
          scope: 'email',
        },
      );
    });
  }
}

export default new FacebookService();
